import { createSafeClientData } from '@/services/core/core.service'
import type { ExchangeData } from './types'

/** Поля ExchangeData, изменившиеся между двумя снимками (procedure / chainCalled merge). */
export function computeExchangeFieldDelta(
  before: ExchangeData | undefined,
  after: ExchangeData | undefined,
): ExchangeData {
  const beforeFields = before?.fields?.fields ?? {}
  const afterFields = after?.fields?.fields ?? {}
  const deltaFields: Record<string, unknown> = {}

  for (const [key, value] of Object.entries(afterFields)) {
    const beforeValue = beforeFields[key]
    if (JSON.stringify(beforeValue) !== JSON.stringify(value)) {
      deltaFields[key] = value
    }
  }

  return createSafeClientData({
    fields: {
      fields: deltaFields,
      fieldAttributes: {},
      errors: {},
      attributes: {},
    },
  })
}
